/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";

export default {
    name: "CtqAddEditModal",
    components: { customModal, Multiselect },
    props: { data: Object },
    emits: ["closeModal", "saveCtq"],

    data() {
        return {
            form: {
                ctqid: "",
                ctqFactor: "",
                ctqDescription: "",
                category: "",
                domain: "",
                priority: "",
                measurement: "",
                impactIfMissing: "",
                isActive: true,
                approvalStatus: "",
                risks: [],
                linkedKRIs: [],
                criticalDataPoints: [],
                criticalProcesses: [],
                qtLs: [],
                reviewPlan: {
                    reviewFrequency: "",
                    reviewOwner: "",
                    reviewMethod: "",
                },
            },
            errors: {
                ctqFactor: "",
                ctqid: "",
                category: "",
            },
            riskError: "",
            kriError: "",
            cdpError: "",
            processError: "",
            qtlError: "",
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: "",
            token: "",
            templates: [],
            templateFields: [],
            selectedTemplateId: "",
            selectedFields: [],
            maxVisibleFields: 3,
            kriOptions: [],
            qtlOptions: [],
        };
    },

    async mounted() {
        window.addEventListener("studyIdChanged", () => {
            this.studyId = store.getters.getStudyIs;
            this.token = store.getters.getIdToken;
            this.loadTemplates();
            this.getQtlOptions();
        });
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.loadTemplates();
        this.getKriOptions();
        this.getQtlOptions();
    },

    computed: {
        isEditMode() {
            return !!this.data?.studyCTQId;
        },
    },

    watch: {
        data: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && newVal.studyCTQId) {
                    this.mapEditData(newVal);
                }
            },
        },
    },

    methods: {

        closeModal() {
            this.$emit("closeModal");
        },

        // ── Risks ───────────────────────────────────────────────────────
        addRisk() {
            const last = this.form.risks[this.form.risks.length - 1];
            if (last && !last.riskId && !last.riskName) {
                this.riskError = "Please complete the previous risk row.";
                return;
            }
            this.riskError = "";
            this.form.risks.push({ riskId: "", riskName: "" });
        },
        removeRisk(i) {
            this.form.risks.splice(i, 1);
            this.riskError = "";
        },

        // ── Linked KRIs ─────────────────────────────────────────────────
        addLinkedKRI() {
            const last = this.form.linkedKRIs[this.form.linkedKRIs.length - 1];
            if (last && !last.categoryId && !last.riskIndicator) {
                this.kriError = "Please complete the previous KRI row.";
                return;
            }
            this.kriError = "";
            this.form.linkedKRIs.push({ categoryId: "", riskIndicator: "" });
        },
        removeLinkedKRI(i) {
            this.form.linkedKRIs.splice(i, 1);
            this.kriError = "";
        },
        onKriChange(index, event) {
            const selectedId = event.target.value;
            const selected = this.kriOptions.find((r) => r.value === selectedId);
            this.form.linkedKRIs[index].categoryId = selected?.value || "";
            this.form.linkedKRIs[index].riskIndicator = selected?.label || "";
            this.kriError = "";
        },

        // ── Critical Data Points ────────────────────────────────────────
        visibleFields(c) {
            if (!Array.isArray(c.fieldLabels)) return [];
            return c.showAll
                ? c.fieldLabels
                : c.fieldLabels.slice(0, this.maxVisibleFields);
        },
        toggleFields(c) {
            c.showAll = !c.showAll;
        },
        async addCriticalDataPoint() {
            this.cdpError = "";
            if (!this.selectedTemplateId) {
                this.cdpError = "Please select a template";
                return;
            }
            const template = this.templates.find(
                (t) => t.templateId === this.selectedTemplateId
            );
            const fieldnames = this.selectedFields.map((f) => f.fieldName);
            const fieldLabels = this.selectedFields.map((f) => f.label);
            this.form.criticalDataPoints.push({
                formId: template?.templateName,
                templateName: template?.templateName,
                fieldnames: fieldnames.length ? fieldnames : [],
                fieldLabels: fieldLabels.length ? fieldLabels : [],
                showAll: false,
            });
            this.selectedTemplateId = "";
            this.selectedFields = [];
            this.templateFields = [];
        },
        removeCriticalDataPoint(index) {
            this.form.criticalDataPoints.splice(index, 1);
        },

        // ── Critical Processes ──────────────────────────────────────────
        addCriticalProcess() {
            const last =
                this.form.criticalProcesses[this.form.criticalProcesses.length - 1];
            if (last && !last.processId && !last.processName) {
                this.processError = "Please complete the previous process row.";
                return;
            }
            this.processError = "";
            this.form.criticalProcesses.push({ processId: "", processName: "" });
        },
        removeCriticalProcess(i) {
            this.form.criticalProcesses.splice(i, 1);
            this.processError = "";
        },

        // ── QTLs ────────────────────────────────────────────────────────
        addQtl() {
            const last = this.form.qtLs[this.form.qtLs.length - 1];
            if (last && !last.qtlid && !last.qtlName) {
                this.qtlError = "Please complete the previous QTL row.";
                return;
            }
            this.qtlError = "";
            this.form.qtLs.push({ qtlid: "", qtlName: "" });
        },
        removeQtl(i) {
            this.form.qtLs.splice(i, 1);
            this.qtlError = "";
        },
        onQtlChange(index, event) {
            const selectedId = event.target.value;
            const selected = this.qtlOptions.find((q) => q.value === selectedId);
            this.form.qtLs[index].qtlid = selected?.value || "";
            this.form.qtLs[index].qtlName = selected?.label || "";
            this.qtlError = "";
        },
        getCtQId(qtlid) {
            const opt = this.qtlOptions.find((o) => o.value === qtlid);
            return opt ? opt.ctQId : qtlid;
        },

        // ── Template loading ────────────────────────────────────────────
        async loadTemplates() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/forms/template/listtemplate`,
                    {
                        params: { StudyID: this.studyId },
                        headers: { Authorization: `Bearer ${this.token}` },
                    }
                );
                this.templates = res.data.results || [];
            } catch (err) {
                console.error("Failed to load templates", err);
            }
        },
        async onTemplateChange() {
            if (this.selectedTemplateId) this.cdpError = "";
            this.selectedFields = [];
            this.templateFields = [];
            if (!this.selectedTemplateId) return;
            try {
                const res = await axios.get(
                    `${this.baseurl}/forms/template/get/${this.selectedTemplateId}`,
                    { headers: { Authorization: `Bearer ${this.token}` } }
                );
                const pages = res.data.pages || [];
                this.templateFields = pages.flatMap((p) =>
                    (p.field || [])
                        .filter((f) => !["header", "subHeader"].includes(f.type))
                        .map((f) => ({
                            fieldName: f.fieldName,
                            label: f.label || f.fieldName,
                        }))
                );
            } catch (err) {
                console.error("Failed to load template fields", err);
                this.templateFields = [];
            }
        },

        // ── KRI options ─────────────────────────────────────────────────
        async getKriOptions() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/forms/rbqm/paginatedindicator`,
                    {
                        params: { StudyId: this.studyId, SortProperty: "", SortOrder: 0 },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const list = res.data.entities || [];
                this.kriOptions = list
                    .filter(
                        (item) => item.riskIndicator && item.riskIndicator.trim() !== ""
                    )
                    .sort((a, b) => a.riskIndicator.localeCompare(b.riskIndicator))
                    .map((item) => ({
                        label: item.riskIndicator,
                        value: item.categoryId,
                    }));
            } catch (err) {
                console.log("Error loading KRI options", err);
            }
        },

        // ── QTL options ─────────────────────────────────────────────────
        async getQtlOptions() {
            try {
                const res = await axios.get(`${this.baseurl}/forms/qtl/listall`, {
                    params: { StudyId: this.studyId },
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                        "Content-Type": "application/json",
                    },
                });
                const list = res.data.entities || [];
                this.qtlOptions = list
                    .filter((item) => item.qtlName && item.qtlName.trim() !== "")
                    .sort((a, b) => a.qtlName.localeCompare(b.qtlName))
                    .map((item) => ({
                        label: item.qtlName,
                        value: item.id,
                        ctQId: item.ctQId,
                    }));
            } catch (err) {
                console.log("Error loading QTL options", err);
            }
        },
        
        // ── Validation ──────────────────────────────────────────────────
        validateForm() {
            this.errors.ctqFactor = "";
            this.errors.ctqid = "";
            this.errors.category = "";
            let isValid = true;
            if (!this.form.ctqFactor) {
                this.errors.ctqFactor = "CtQ Factor is required";
                isValid = false;
            }
            if (!this.form.ctqid) {
                this.errors.ctqid = "CTQ ID is required";
                isValid = false;
            }
            if (!this.form.category) {
                this.errors.category = "Category is required";
                isValid = false;
            }
            return isValid;
        },

        // ── Save (Create / Update) ──────────────────────────────────────
       async save() {
    if (!this.validateForm()) return;

    try {
        // Base payload — matches both create and update API schemas
        const payload = {
            studyId: this.studyId,
            studyRef: "",
            ctqid: this.form.ctqid,
            ctqFactor: this.form.ctqFactor,
            ctqDescription: this.form.ctqDescription,
            category: this.form.category,
            domain: this.form.domain,
            priority: this.form.priority,
            measurement: this.form.measurement,
            impactIfMissing: this.form.impactIfMissing,
            isActive: this.form.isActive,
            approvalStatus: this.form.approvalStatus,

            criticalDataPoints: this.form.criticalDataPoints.map((c) => ({
                formId: c.formId,
                fieldnames: c.fieldnames,
            })),

            criticalProcesses: this.form.criticalProcesses.map((p) => ({
                processId: p.processId,
                processName: p.processName,
            })),
        };

        const config = {
            headers: {
                Authorization: `Bearer ${this.token}`,
                "Content-Type": "application/json",
            },
        };

        if (this.isEditMode) {
            payload.studyCTQId = this.data.studyCTQId;
            await axios.put(
                `${this.baseurl}/forms/ctq/updatestudyctq`,
                payload,
                config
            );
        } else {
            await axios.post(
                `${this.baseurl}/forms/ctq/createstudyctq`,
                payload,
                config
            );
        }

        this.$emit("saveCtq");
        alert(
            this.isEditMode
                ? "CtQ updated successfully"
                : "CtQ created successfully"
        );
        this.closeModal();
    } catch (error) {
        console.error("Save CTQ failed:", error);

        const apiErrors = error?.response?.data?.errors;
        const apiDetail = error?.response?.data?.detail;

        let message = this.isEditMode
            ? "Failed to update CtQ. Please try again."
            : "Failed to save CtQ. Please try again.";

        if (apiErrors && typeof apiErrors === "object") {
            const allMessages = Object.values(apiErrors).flat();
            if (allMessages.length) {
                message = allMessages.join("\n");
            }
        } else if (apiDetail) {
            message = apiDetail;
        }

        alert(message);
    }
},

        // ── Map edit data ───────────────────────────────────────────────
        mapEditData(data) {
            this.form = {
                ctqid: data.ctqid || "",
                ctqFactor: data.ctqFactor || "",
                ctqDescription: data.ctqDescription || "",
                category: data.category || "",
                domain: data.domain || "",
                priority: data.priority || "",
                measurement: data.measurement || "",
                impactIfMissing: data.impactIfMissing || "",
                isActive: data.isActive !== undefined ? data.isActive : true,
                approvalStatus: data.approvalStatus || "",

                risks: (data.risks || []).map((r) => ({
                    riskId: r.riskId || "",
                    riskName: r.riskName || "",
                })),

                linkedKRIs: (data.linkedKRIs || []).map((k) => ({
                    categoryId: k.categoryId || "",
                    riskIndicator: k.riskIndicator || "",
                })),

                criticalDataPoints: (data.criticalDataPoints || []).map((c) => ({
                    formId: c.formId || "",
                    templateName: c.formId || "",
                    fieldnames: Array.isArray(c.fieldnames) ? c.fieldnames : [],
                    fieldLabels: Array.isArray(c.fieldnames) ? c.fieldnames : [],
                    showAll: false,
                })),

                criticalProcesses: (data.criticalProcesses || []).map((p) => ({
                    processId: p.processId || "",
                    processName: p.processName || "",
                })),

                qtLs: (data.qtLs || []).map((q) => ({
                    qtlid: q.qtlid || "",
                    qtlName: q.qtlName || "",
                })),

                reviewPlan: {
                    reviewFrequency: data.reviewPlan?.reviewFrequency || "",
                    reviewOwner: data.reviewPlan?.reviewOwner || "",
                    reviewMethod: data.reviewPlan?.reviewMethod || "",
                },
            };
        },
    },
};